import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Observable, Subscription, forkJoin, lastValueFrom, map, switchMap, tap } from 'rxjs';
import { SettingsService } from '../../../contexts/settings/settings.service';
import { PartnerMerchantsService } from 'src/app/contexts/merchants/merchants.service';
import { Params } from 'src/app/contexts/merchants/pages/list/models/params.model';
import { MatDialog } from '@angular/material/dialog';
import { InfoDataBankModalComponent } from './modals/info-data-bank-modal.component';
import { MerchantsGeneralService } from 'src/app/contexts/merchants/merchants-general.service';

@Component({
  selector: 'app-layout-select-merchants',
  templateUrl: './select-merchants.component.html'
})
export class LayoutSelectMerchantsComponent implements OnInit {

  @Output() merchants = new EventEmitter();
  model: any = {};
  @Input() user;
  @Input() merchant;

  subscription: Subscription;
  @Output() getNotifications = new EventEmitter();
  params: Params;

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private settingsService: SettingsService,
    private merchantService: MerchantsGeneralService,
    private keycloakService: KeycloakService
  ) { }

  async ngOnInit() {

    this.model.merchants = [];

    this.route.paramMap.subscribe(params => {
      this.params = new Params(params);

      this.params.page = 1;
      this.params.pageSize = 100000;

      this.model.partner = params.get('partner');
      this.model.account = params.get('account');
      this.model.merchant = params.get('merchant');
    });

    if (await this.keycloakService.isLoggedIn()) {

      var process = [];
      this.user.merchantKeys.forEach(element => {
        var obs = this.merchantService.get(this.model.partner, this.model.account, element);
        process.push(obs);
      }
      );


      forkJoin(process)
        .pipe(
          map(result => {
            result.forEach(element => {
              this.model.merchants.push(element.merchant);
            });
          }),
        )
        .subscribe((response) => {

          this.model.merchants.forEach(element => {
            if (element.configurations) {
              let obj = JSON.parse(element.configurations);
              element.color = obj.Frontend ? obj.Frontend.Color : '#000';
            }
            else
              element.color = '#000';
          });

          this.model.merchantSelected = this.model.merchants?.find(p => p.external_id == this.model.merchant);

          this.settingsService.changeMerchant(this.model.merchantSelected);


          //  this.openPixTypeModal();

          this.getNotification();
          this.firstLetter();

        });

      this.subscription = this.settingsService.currentMerchant.subscribe(merchant => {
        if (merchant)
          if (Object.keys(merchant)?.length > 0) {
            this.model.merchantSelected = merchant;
          }
      });

    }
  }

  openPixTypeModal() {
    if (!(this.model.merchantSelected?.pix_key_type == '6')) {

      this.dialog.open(InfoDataBankModalComponent, {
        panelClass: "custom-modal-merchants",
        autoFocus: false,
        data: {
          partner: this.model.partner,
          account: this.model.account,
          merchant: this.model.merchantSelected,
          user: this.user
        },
      });

      this.getNotification();
    }

  }

  getNotification() {
    this.getNotifications.emit(this.model.merchantSelected);
  }

  settings(merchant) {
    this.model.merchantSelected = merchant;
    this.router.navigate([this.model.partner, this.model.account, merchant.external_id, 'settings', 'merchant']);
  }

  changeMerchant(merchant) {
    if (merchant) {
      if (merchant.external_id) {
        if (merchant.external_id !== this.model.merchantSelected?.external_id) {
          this.model.merchantSelected = merchant;
          this.getNotification();
          //this.openPixTypeModal();
          this.router.navigate([this.model.partner, this.model.account, merchant.external_id, 'payout']);
        }
      }
    }
  }

  firstLetter() {
    if (this.model.merchantSelected)
      this.model.firstLetter = this.model.merchantSelected?.name.charAt(0);
  }
}
